(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ce-hero-premium"] && !Shopify.designMode) return;
  try {
    


(function () {


  function initCEHero(hero) {


    if (!hero) return;


    if (hero.dataset.slider !== 'true') return;


    var slides =
      hero.querySelectorAll(
        '[data-ce-slide]'
      );


    if (!slides.length) return;


    var prev =
      hero.querySelector(
        '[data-ce-prev]'
      );


    var next =
      hero.querySelector(
        '[data-ce-next]'
      );


    var dots =
      hero.querySelectorAll(
        '[data-ce-dot]'
      );


    var current = 0;

    var timer = null;


    var autoplay =
      hero.dataset.autoplay === 'true';


    var speed =
      parseInt(
        hero.dataset.speed,
        10
      ) || 6000;



    function showSlide(index) {


      if (index < 0) {
        index =
          slides.length - 1;
      }


      if (index >= slides.length) {
        index = 0;
      }


      current = index;


      slides.forEach(
        function (slide, i) {


          var active =
            i === current;


          slide.classList.toggle(
            'is-active',
            active
          );


          slide.setAttribute(
            'aria-hidden',
            active
              ? 'false'
              : 'true'
          );


        }
      );


      dots.forEach(
        function (dot, i) {


          dot.classList.toggle(
            'is-active',
            i === current
          );


        }
      );


    }



    function stopAutoplay() {


      if (timer) {

        clearInterval(timer);

        timer = null;

      }


    }



    function startAutoplay() {


      stopAutoplay();


      if (!autoplay) return;


      if (
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }


      timer =
        setInterval(
          function () {

            showSlide(
              current + 1
            );

          },
          speed
        );


    }



    if (prev) {


      prev.addEventListener(
        'click',
        function () {


          showSlide(
            current - 1
          );


          startAutoplay();


        }
      );


    }



    if (next) {


      next.addEventListener(
        'click',
        function () {


          showSlide(
            current + 1
          );


          startAutoplay();


        }
      );


    }



    dots.forEach(
      function (dot) {


        dot.addEventListener(
          'click',
          function () {


            var target =
              parseInt(
                dot.dataset.ceDot,
                10
              );


            showSlide(target);


            startAutoplay();


          }
        );


      }
    );



    hero.addEventListener(
      'mouseenter',
      stopAutoplay
    );


    hero.addEventListener(
      'mouseleave',
      startAutoplay
    );



    showSlide(0);


    startAutoplay();


  }



  function initAllCEHeroes() {


    document
      .querySelectorAll(
        '[data-ce-hero]'
      )
      .forEach(
        function (hero) {

          initCEHero(hero);

        }
      );


  }



  document.addEventListener(
    'DOMContentLoaded',
    initAllCEHeroes
  );



  document.addEventListener(
    'shopify:section:load',
    function (event) {


      var hero =
        event.target.querySelector(
          '[data-ce-hero]'
        );


      if (hero) {

        initCEHero(hero);

      }


    }
  );



  document.addEventListener(
    'shopify:block:select',
    function (event) {


      var block =
        event.target;


      if (
        !block ||
        !block.matches(
          '[data-ce-slide]'
        )
      ) {
        return;
      }


      var hero =
        block.closest(
          '[data-ce-hero]'
        );


      if (!hero) return;


      var slides =
        Array.from(
          hero.querySelectorAll(
            '[data-ce-slide]'
          )
        );


      var index =
        slides.indexOf(block);


      slides.forEach(
        function (slide, i) {


          slide.classList.toggle(
            'is-active',
            i === index
          );


          slide.setAttribute(
            'aria-hidden',
            i === index
              ? 'false'
              : 'true'
          );


        }
      );


      var dots =
        hero.querySelectorAll(
          '[data-ce-dot]'
        );


      dots.forEach(
        function (dot, i) {

          dot.classList.toggle(
            'is-active',
            i === index
          );

        }
      );


    }
  );


})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
